export { default } from './getScrollbarSize';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/getScrollbarSize/index.js
// module id = 841
// module chunks = 25